const STORAGE_KEY = 'pinpoint.adminReturnTo';

// Only local admin pages may become a login destination. Never persist CAS
// tickets or auth tokens with a return path, or accept encoded URL separators.
export function safeAdminReturnTo(value) {
  // Reject literal control characters as well as encoded URL separators.
  // eslint-disable-next-line no-control-regex
  if (typeof value !== 'string' || !/^\/admin(?:\/|$|\?|#)/.test(value) || /[\\\u0000-\u001f]|%2f|%5c/i.test(value)) return null;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || !/^\/admin(?:\/[a-z0-9_-]+)*\/?$/i.test(url.pathname)) return null;
    for (const key of [...url.searchParams.keys()]) {
      if (/ticket|token|secret|password/i.test(key)) url.searchParams.delete(key);
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return null; }
}

export function rememberAdminReturnTo(location) {
  const path = safeAdminReturnTo(`${location.pathname}${location.search || ''}${location.hash || ''}`);
  if (path) { try { sessionStorage.setItem(STORAGE_KEY, path); } catch {} }
}

export function getAdminReturnTo() {
  try { return safeAdminReturnTo(sessionStorage.getItem(STORAGE_KEY)); } catch { return null; }
}

export function clearAdminReturnTo() {
  try { sessionStorage.removeItem(STORAGE_KEY); } catch {}
}
